export const sectionTitle = [
  {
    label: 'Symbols and Templates',
    id: 'symbolsAndTemplates',
  },
  {
    label: 'User Access Management',
    id: 'userAccessManagement',
  },
  {
    label: 'Tips for Escape Planning',
    id: 'tipsForEscapePlanning',
  },
  {
    label: 'Printing Service Integration',
    id: 'printingService',
  },
  {
    label: 'Multilingual Support',
    id: 'multilingualSupport',
  },
];

export const escapePlanning = [
  {
    title: 'Complete Profile Setup',
    desc: 'Complete your profile setup accurately, including contact details and preferred delivery address, to streamline communication and ensure smooth order processing.',
  },
  {
    title: 'Upload Building Drawings',
    desc: 'When uploading building drawings, ensure the file format is correct and all relevant details are included. This facilitates the CAD conversion process, helping technicians create precise escape plans.',
  },
  {
    title: 'Review Job Details Thoroughly',
    desc: 'Before sending proposals or accepting contracts, review all job details provided by clients to tailor your proposals effectively and prevent misunderstandings.',
  },
  {
    title: 'Send Detailed Proposals',
    desc: 'When sending proposals to clients, include comprehensive service details such as pricing, turnaround time, and additional terms to facilitate informed decision-making.',
  },
  {
    title: 'Promptly Commence Drawing process',
    desc: 'Upon receiving contracts from clients, initiate the drawing process promptly to ensure timely delivery of escape plans. Adhering to deadlines will enhance client satisfaction and reputation.',
  },
  {
    title: 'Respond Promptly to Admin Feedback',
    desc: 'If issues are identified during the review process by admins, address them promptly and thoroughly. Clear communication and swift resolution of issues will expedite the approval process and minimize delays.',
  },
  {
    title: 'Ensure Client Satisfaction',
    desc: 'Prioritize client satisfaction by actively seeking feedback, addressing concerns, and delivering high-quality escape plans. Satisfied clients are more likely to return for future projects and recommend your services.',
  },
  {
    title: 'Utilize Payment and Completion Features',
    desc: 'Take advantage of the secure payment options available on the platform to complete transactions efficiently. Once the project is marked as completed, ensure timely delivery of finalized escape plans to clients.',
  },
];

export const printingService = [
  {
    title: 'Seamless Integration',
    desc: ' Our platform effortlessly integrates with printers, enabling clients to assign tasks directly or create dedicated jobs for printing.',
  },
  {
    title: 'Efficiency',
    desc: 'Clients easily designate preferred printers for drawing reproduction, ensuring a smooth and efficient printing process.',
  },
  {
    title: 'Streamlined Workflow',
    desc: 'With our streamlined system, tasks are promptly assigned, fostering seamless communication between clients and printers.',
  },
  {
    title: 'Flexibility',
    desc: 'Clients enjoy flexibility in choosing printers or exploring alternative printing options to meet their specific needs.',
  },
  {
    title: 'Secure Delivery and Communication',
    desc: 'rinters ensure secure delivery to specified addresses, while clients track job progress and communicate transparently through our platform.',
  },
];
